import * as React from 'react';
import styles from './GiftPromo.scss';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '~/Reducers';
import { OrangeButton } from '~/components/Button/Buttons';
import { t } from '~/utils/localization';
import { giftStatus } from '~/Actions/ActionAccount';
import { playButtonClickSound } from '~/api/WoWsClient';
import { takeGift } from '~/api/gifts';
import Attention from '~/components/Attention/Attention';
import { isMobileOrTabletWindow, redirectToLogin } from '~/utils/utils';
import GiftIntroWidget from '~/components/GiftPromo/GiftIntroWidget';
import equal from 'fast-deep-equal/react';
import ButtonEsc from '~/components/ButtonEsc/ButtonEsc';
import { updateBrowserControlState } from '@wg/web2clientapi/browser/updateBrowserControlState';
import useKeyDown, { KEYS_CODE } from '~/hooks/useKeyDown';
import { markShownWelcomeGiftScreen } from '~/utils/gift';

export type INITIAL = 0;
export type IN_PROGRESS = 1;
export type ERROR = 2;
export type SUCCESS = 3;

export const INITIAL = 0;
export const IN_PROGRESS = 1;
export const ERROR = 2;
export const SUCCESS = 3;

interface IStateSelector {
    accountId: number;
    gifts: IGift[];
}

const stateSelector = (state: State): IStateSelector => {
    return {
        accountId: state.ReducerAccount.id,
        gifts: state.ReducerAccount.gifts.bundles,
    };
};

const GiftPromo = () => {
    const dispatch = useDispatch();
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const isGuest = !state.accountId;
    const currentGift = state.gifts[0];
    const [status, setStatus] = React.useState<number>(INITIAL);
    const [isVisiblePopup, toggleVisiblePopup] = React.useState<boolean>(isMobileOrTabletWindow);

    const close = () => {
        if (isGuest) {
            markShownWelcomeGiftScreen(currentGift.name);
        } else {
            updateBrowserControlState(false);
        }
        const gifts = [...state.gifts];
        gifts.shift();
        toggleVisiblePopup(false);
        setStatus(INITIAL);
        dispatch(giftStatus(Boolean(gifts.length) as any, gifts));
    };

    const takeMyGift = () => {
        markShownWelcomeGiftScreen(currentGift.name);

        if (isGuest) {
            redirectToLogin();
            return;
        }

        setStatus(IN_PROGRESS);
        takeGift(currentGift.id)
            .then(() => {
                updateBrowserControlState(true);
                setStatus(SUCCESS);
                const timeout = setTimeout(() => {
                    clearTimeout(timeout);
                    close();
                }, 3000);
            })
            .catch(() => {
                updateBrowserControlState(true);
                setStatus(ERROR);
            });
    };

    const label = status === IN_PROGRESS ? t('Обработка') : t('Забрать подарок');

    const isDisabled = status !== INITIAL && status !== ERROR;

    useKeyDown(() => {
        if (status === ERROR || status === SUCCESS) {
            playButtonClickSound();
            close();
        }
    }, [KEYS_CODE.ESC]);

    if (!isVisiblePopup) {
        return (
            <GiftIntroWidget
                onClick={() => {
                    toggleVisiblePopup(true);
                }}
            />
        );
    }

    return (
        <div className={styles.giftPromo} style={{ backgroundImage: `url(${currentGift.icons.innerBackground})` }}>
            {(isGuest || status === ERROR || status === SUCCESS) && (
                <div className={styles.close}>
                    <ButtonEsc onClick={close} />
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.main}>
                    <div className={styles.title}>{currentGift.title}</div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: currentGift.description }} />
                    <div className={styles.status}>
                        {status === ERROR && <Attention label={t('Произошла ошибка. Повторите попытку или заберите подарок позднее.')} level={'error'} className={styles.attention} />}
                        {status === SUCCESS && <Attention label={t('Подарок успешно получен')} level={'done'} className={styles.attention} />}
                    </div>
                    {status !== SUCCESS && (
                        <div className={styles.buttonWrapper}>
                            <OrangeButton label={label} onClick={takeMyGift} disabled={isDisabled} className={styles.button} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GiftPromo;
